import { useState, Dispatch, SetStateAction } from "react";
import useAxios from "./useAxios";
import { TError } from "../../types/common";

type RequestConfig = {
  api: string;
  loader: Dispatch<SetStateAction<boolean>>;
  errorHandler: Dispatch<SetStateAction<TError>>;
  successHandler: (res: any) => void;
  methodName: string;
  type?: "application/json" | "multipart/form-data";
  data?: any;
  params?: any;
};

type UploadDataParams = {
  api: string;
  params?: any;
  data?: any;
  id?: number | string;
  type?: "application/json" | "multipart/form-data";
  method?: string;
  onSuccess?: (data: any) => void;
  reloadData?: () => void;
};

export interface IFormSubmit extends UploadDataParams {}

const useSet = () => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<TError>({});
  const [success, setSuccess] = useState<boolean>(false);
  const [data, setData] = useState<any>();
  const { set } = useAxios();

  const uploadData = (options: UploadDataParams) => {
    const { api, params, data, method, type, id, onSuccess } = options;
    const extras = {};

    // If id is passed get single instance, other fetch list
    setError({});
    setSuccess(false);
    setSubmitting(true);

    const requestConfig: RequestConfig = {
      api: id ? `${api}${id}/` : api,
      loader: setSubmitting,
      errorHandler: setError,
      successHandler: (res: any) => {
        // console.log("RES", res);
        setData(res);
        setSuccess(true);
        onSuccess?.(res); // set data to success
      },
      methodName: method || (id ? "PATCH" : "POST"),
      type,
    };

    // For PATCH/PUT requests, use data, otherwise use params
    if (data) {
      requestConfig.data = data;
    } else {
      requestConfig.params = { ...params, ...extras };
    }

    set(requestConfig);
  };

  const updateErrors = (err: TError) => {
    setError(err ? { ...error, ...err } : {});
  };

  return {
    submitting,
    error,
    data,
    success,
    uploadData,
    updateErrors,
    setError,
    setSuccess,
  };
};

export default useSet;
